
import styled from "styled-components";
import EngagementIntro from "../components/Engagement/EngagementIntro";
import UserJourney from "../components/Engagement/UserJourney";
import FlexibleLinks from "../components/Engagement/FlexibleLinks";
import HowItWorksEngagement from "../components/Engagement/HowItWorks";

import GetStartedRequestDemoSide from "../components/generic/GetStartedRequestDemoSide";
import TrackingComponent from "../components/Tracking/TrackingComponent";
import { lightThemeColors } from "../assets/style/colors";
import { ReactComponent as GridDecoration } from "../assets/decorations/greenBannerGrid.svg";
import { Helmet } from "react-helmet-async";

const Engagement = () => {

    return (
        <>
            <Helmet>
                <title>
                    Grovs Engagement | Drive Installs & Boost Retention with Dynamic Links
                </title>
                <meta
                    name="description"
                    content="Grovs Dynamic Links help you guide users directly to the right content—across devices. Reduce drop-off, personalize onboarding, and track every journey with ease."
                />
                <meta
                    name="keywords"
                    content="dynamic links, deferred deep linking, app engagement, user journey optimization, cross-platform experience, personalized onboarding, install tracking, Grovs Engagement"
                />
                <meta name="robots" content="index, follow" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Grovs Engagement | Personalized, Frictionless App Journeys"
                />
                <meta
                    property="og:description"
                    content="Deliver seamless user experiences and track every install, open, and referral with Grovs Dynamic Links. Cut friction and boost engagement across platforms."
                />
                <meta property="og:url" content="https://www.grovs.io/engagement" />
                <meta
                    property="og:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
                />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:title"
                    content="Grovs Engagement | Smart Links for Smoother App Experiences"
                />
                <meta
                    name="twitter:description"
                    content="Say goodbye to broken links and clunky onboarding. Grovs Dynamic Links ensure smooth, trackable journeys that drive installs and improve retention."
                />
                <meta
                    name="twitter:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
                />
            </Helmet>
            <Container>
                <EngagementIntro />
                <UserJourney />
                <FlexibleLinks />
                <HowItWorksEngagement />

                <GetStartedRequestDemoSide
                    bgColor={lightThemeColors.engagementBg}
                    gradientColor={"rgba(9, 58, 50, 1)"}
                    titleStyle={{ color: lightThemeColors.lightColor }}
                    subtitleStyle={{ color: lightThemeColors.lightColorFaded7 }}
                    gridDecoration={<GridDecoration />}
                    primaryButtonStyle={{ color: lightThemeColors.lightColor }}
                    primaryButtonVariant={lightThemeColors.footerBg}
                    outlineButtonStyle={{
                        color: lightThemeColors.darkColor,
                        background: lightThemeColors.lightColor,
                    }}
                    outlineButtonVariant={lightThemeColors.lightColor}
                    title={"Stop Losing Users—Start Today!"}
                    subtitle={
                        " Ready to enhance your app’s user experience? With Dynamic Links, you can streamline installs, track referrals, and deliver personalized"
                    }
                />
                <TrackingComponent />
            </Container>
        </>
    );
};
export default Engagement;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
